<template>
	<div ref="main" class="sw_container" @scroll="handleScroll">

		<div class="general_back_top" v-if="isShowScrollBtn" @click="scrollToTop">
			<img class="icon" src="../../assets/image/shang.png" alt="" />
			<div>返回顶部</div>
		</div>

		<!-- 头部 -->
		<div class="sw_panel" id="anchor_0">
			<img src="../../assets/images/solidworks_banner.jpg" style="height:450px;">
			<div class="sw_inner header_box">
				<div class="title_box">
					<div class="title">
						SOLIDWORKS认证考试官方报名中心
					</div>
					<div class="tabs">
						<div class="tab" :class="{'actived':tab_index == 1}" @click="changeTab(1)">
							SOLIDWORKS认证指导系列丛书
							<div class="line"></div>
						</div>
						<div class="tab" :class="{'actived':tab_index == 2}" @click="changeTab(2)">
							SOLIDWORKS认证考试报名
							<div class="line"></div>
						</div>
						<div class="tab" :class="{'actived':tab_index == 3}" @click="changeTab(3)">
							线下培训预告及前期回顾
							<div class="line"></div>
						</div>
						<div class="tab" :class="{'actived':tab_index == 4}" @click="changeTab(4)">
							SOLIDWORKS线上课程
							<div class="line"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- SOLIDWORKS认证指导系列丛书 -->
		<div id="anchor_1" class="sw_panel panel_1">
			<div class="sw_inner body_box body_box_v">
				<div class="body_title_box">
					<div class="number">01</div>
					<div class="title">SOLIDWORKS认证指导系列丛书</div>
				</div>
				<div class="body_text_box">
					SOLIDWORKS系列丛书以认证考试为主线，包含SOLIDWORKS CSWA认证指导、SOLIDWORKS
					Simulation基础教程+高级教程、SOLIDWORKS工程图教程+高级教程简编+零件与装配体教程等图书，助力学习者掌握SOLIDWORK操作技巧，认证考试无忧。
				</div>
				<div class="s_image_box">
					<img src="../../assets/images/solidworks_books.jpg" style=" width: 960px;" />
				</div>
				<div class="link_box">
					丛书详情请访问：<a href="https://item.jd.com/12762399.html"
						target="_blank">https://item.jd.com/12762399.html</a>
				</div>
			</div>
		</div>


		<!-- SOLIDWORKS认证考试报名 -->
		<div id="anchor_2" class="sw_panel panel_2">
			<div class="sw_inner body_box">
				<div class="image_box" style="margin-right: 25px;">
					<img src="../../assets/images/solidworks_camp.jpg" />
				</div>
				<div class="content_box">
					<div class="body_title_box">
						<div class="number">02</div>
						<div class="title">SOLIDWORKS认证考试报名</div>
					</div>
					<div class="body_text_box">
						SOLIDWORKS认证考试是DSSOLIDWORKS公司推出的全球性认证考试项目，是作为衡量您所具备的SOLIDWORKS应用专长与能力的一种测试和认可主要考察对设计、仿真一体化SOLIDWORKS软件的使用水平以及解决问题的能力。SOLIDWORKS作为实质意义上的三维设计标准，该证书被全球大部分的工业企业视为CAD应用工程师的能力凭证，在美国、加拿大、日本、欧盟等大部分国家和地区得到了广泛的认可。
					</div>
					<div class="link_box">
						报名入口请访问：<a href="https://g.cmptt.com/ng1oa" target="_blank">https://g.cmptt.com/ng1oa</a>
					</div>
				</div>

			</div>
		</div>


		<!-- 线下培训预告及前期回顾 -->
		<div id="anchor_3" class="sw_panel panel_1">
			<div class="sw_inner body_box">
				<div class="content_box">
					<div class="body_title_box">
						<div class="number">03</div>
						<div class="title">线下培训预告及前期回顾</div>
					</div>
					<div class="body_text_box">
						三维软件作为装备制造大类的专业基础课程对于后续专业课程的学习有着重要的保障作用。鉴于企业对熟练掌握SOLIDWORKS的毕业生有大量需求，广大院校对于相关教学体系的要求也在逐年提升，为有效开展SOLIDWORKS软件实验教学，提升教师的相关教学能力，交流前沿的教学理念，经中国机械工业教育协会同意，中国机械工业教育协会职工教育分会拟举办“SOLIDWORKS教师能力提升特训营”。
					</div>
					<div class="link_box">
						2026年预报名入口请访问：<a href="https://g.cmptt.com/ydnBn" target="_blank"> https://g.cmptt.com/ydnBn</a>
					</div>
				</div>

				<div class="image_box" style="margin-left: 25px;">
					<img src="../../assets/images/solidworks_preview.jpg" />
				</div>
			</div>
		</div>


		<div class="sw_panel panel_2">
			<div class="sw_inner body_box">
				<div class="player_box">
					<iframe
						src="https://web.sdk.qcloud.com/player/tcplayer/samples/vod-player.html?appID=1365070539&fileID=5145403702784960369&autoplay=false&width=3840&height=2160&definition=100800&ssign=1"
						frameborder="0" width="450" height="254" allowfullscreen="true" align="center"></iframe>
				</div>
				<div class="content_box">
					<div class="body_title_box">
						<div class="number">04</div>
						<div class="title">线下培训前期回顾
						</div>
					</div>
					<div class="body_text_box">
						本次SOLIDWORKS教师能力提升特训营培训已圆满收官，这是一次高密度、强实践的知识赋能之旅。在行业资深专家的面对面引领下，通过密集的案例讲解、模拟实践与现场答疑，将理论知识与工程实战深度融合，强力助推学员跨越从“知道”到“精通”的鸿沟。
					</div>
				</div>
			</div>
		</div>

		<!-- 线上培训课程 -->
		<div id="anchor_4" class="sw_panel panel_1">
			<div class="sw_inner body_box body_box_v">
				<div class="body_title_box">
					<div class="number">05</div>
					<div class="title">线上培训课程</div>
				</div>
				<div class="body_text_box">
					线上培训课程以“直播+录播+社群”三维一体的灵活模式，由资深认证专家领航，通过大量实战案例与模拟实操精准教学,并配备专属答疑、无限次回放及全套内部资料等全程服务，旨在助您高效学习、真正掌握SOLIDWORKS核心技能。
				</div>

				<div class="course_list" v-if="course_list">
					<div class="item" v-for="(item,index) in course_list" @click="toDetail(item)">
						<img class="cover" v-lazy="course_img_url" v-if="item.img_url_tt==''" />
						<img class="cover" v-lazy="item.img_url_tt" v-if="item.img_url_tt!=''" />
						<div class="info">
							<div class="title_box">
								<div class="title">{{item.title}}</div>
								<!-- <div class="author">主讲人：{{item.author}}</div> -->
							</div>
							<div class="exts_box">
								<div class="res_info">
									<div class="res_count">{{item.res_count}}小节</div>
									<div class="res_length"><i class="el-icon-pie-chart icon"></i>{{item.res_length}}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>


		<div class="sw_panel" style="background-color: #333333;">
			<div class="sw_inner footer_box">
				© 2025
			</div>
		</div>

	</div>
</template>

<script>
	import apiUrl from "../../js/apiUrl.js";
	import comm from "../../js/comm.js";


	export default {
		data() {
			return {
				id: null,
				tab_index: 1,
				course_list: null,
				course_img_url: require("../../assets/images/cover.png"),
				isShowScrollBtn: false,
			};
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll);
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		},
		created() {
			document.title = "SolidWorks - 机工教师特训营";
			this.getCourseList();
		},

		methods: {
			changeTab(index) {
				this.tab_index = index;
				const element = document.getElementById('anchor_' + index);
				element.scrollIntoView({
					behavior: 'smooth',
					block: 'start'
				});
			},
			getCourseList() {
				var that = this;
				var parms = {
					page_index: 1,
					page_size: 12,
					tag: 'solidworks',
				};
				var url = apiUrl.tt_course_list_get;
				this.Ajax(url, parms, (data) => {
					if (data) {
						that.course_list = data.list;
					}
				});
			},
			toDetail(item) {
				this.GoToDetail(item.product_type, item.id);
			},
			handleScroll(e) {
				let scrollY = e.target.scrollTop;
				console.log(scrollY)
				this.isShowScrollBtn = scrollY > 200;
			},
			scrollToTop() {
				this.$refs.main.scrollTo({
					top: 0,
					behavior: "smooth",
				});
			}
		},
	};
</script>

<style lang="scss" scoped>
	.sw_container {
		width: 100%;
		height: 100vh;
		overflow: auto;
		background: #F1F1F1;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;

		.general_back_top {
			width: 80px;
			height: 80px;
			background: #000000;
			border-radius: 8px;
			border-radius: 8px;
			opacity: 0.3;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			position: fixed;
			bottom: 90px;
			right: 70px;
			cursor: pointer;
			z-index: 2000;
			font-size: 12px;
			color: #fff;

			.icon {
				width: 32px;
				height: auto
			}
		}

		.course_list {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			margin-top: 20px;



			.item {
				width: 206px;
				height: 190px;
				margin-right: 20px;
				margin-bottom: 20px;
				cursor: pointer;
				overflow: hidden;
				display: flex;
				flex-direction: column;
				border-radius: 8px;

				&:nth-child(5n+5) {
					margin-right: 0;
				}

				&:hover {
					box-shadow: -1px 2px 5px 0 rgba(0, 0, 0, 0.1);
					border-radius: 8px;
				}

				.cover {
					width: 100%;
				}

				.info {
					flex: 1;
					background-color: #F1F1F1;
					display: flex;
					flex-direction: column;

					.title_box {
						flex: 1;
						display: flex;
						flex-direction: column;
						padding: 8px;

						.title {
							font-size: 15px;
							font-weight: 600;
							line-height: 1.2;
							display: -webkit-box;
							overflow: hidden;
							text-overflow: ellipsis;
							line-clamp: 2;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;
							max-height: calc(1.5em * 2);
						}

						.author {
							font-size: 18px;
							line-height: 1;
							margin-top: 8px;
						}
					}

					.exts_box {
						width: 100%;
						height: 40px;
						border-radius: 0 0 8px 8px;
						border-top: 1px solid #E8E8E8;
						display: flex;
						justify-content: space-between;
						align-items: center;
						padding: 0 8px;
						box-sizing: border-box;

						.res_info {
							width: 100%;
							display: flex;
							justify-content: space-between;
							align-items: center;
							font-size: 12px;


							.res_count {
								background-color: #c93a2e;
								color: #fff;
								padding: 2px 8px;
								border-radius: 20px;
							}

							.res_length {
								margin-left: 8px;

								.icon {
									margin-right: 2px;
								}
							}
						}

					}
				}
			}
		}


		.sw_panel {
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;

			&.panel_1 {
				background-color: #EBEEF5;
			}

			&.panel_2 {
				background-color: #F3F7FF;
			}
		}

		.sw_inner {
			width: 1200px;

			&.body_box {
				display: flex;
				padding: 45px;
				box-sizing: border-box;
				
				.image_box {
					width: 450px;
					padding-top: 75px;
				
					img {
						width: 450px;
					}
				}
				
				.player_box {
					width: 450px;
					height: 350px;
					padding-top: 75px;
					margin-right: 25px;
					overflow-y: hidden;
				}
				
				.content_box {
					flex: 1;
				}
				
				.body_title_box {
					width: 100%;
					position: relative;
					height: 55px;
					line-height: 1;

					.number {
						font-size: 60px;
						color: #EADBE0;
						font-weight: 600;
						position: absolute;
						bottom: -6px;
						left: -50px;
						z-index: 1;
						font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
					}

					.title {
						font-size: 32px;
						color: #E8301E;
						z-index: 99;
						position: absolute;
						bottom: 0;
					}
				}

				.body_text_box {
					font-size: 20px;
					line-height: 1.75;
					margin-top: 20px;
					text-align: justify;
				}

				.link_box {
					width: 100%;
					font-size: 20px;
					color: #E8301E;
					margin-top: 20px;

					a {
						color: #E8301E;
						border-bottom: 1px solid #E8301E;
					}
				}
				
				&.body_box_v{
					flex-direction: column;
					
					.s_image_box {
						width: 100%;
						height: 350px;
						display: flex;
						justify-content: center;
						align-items: center;
					}
					
					.link_box {
						margin-top: 0;
						display: flex;
						justify-content: center;
						align-items: center;
					}
				}
			}

			&.footer_box {
				height: 200px;
				color: #d1d1d1;
				font-size: 16px;
				padding: 20px;
			}

			&.header_box {
				height: 450px;
				position: absolute;
				top: 0;

				.title_box {
					width: 100%;
					height: 450px;
					display: flex;
					justify-content: center;
					align-items: center;
					position: relative;

					.title {
						font-size: 65px;
						line-height: 1.2;
						text-align: center;
						color: #fff;
						font-weight: 600;
						position: absolute;
						top: 150px;
					}

					.tabs {
						width: 100%;
						padding: 0 30px;
						box-sizing: border-box;
						display: flex;
						justify-content: space-around;
						align-items: center;
						position: absolute;
						left: 0;
						bottom: 70px;


						.tab {
							cursor: pointer;
							font-size: 20px;
							line-height: 3;
							color: #fff;
							display: flex;
							justify-content: center;

							.line {
								width: 5em;
								height: 2px;
								background-color: #fff;
								position: absolute;
								top: 56px;
								display: flex;

							}


							&:hover {
								.line {
									width: 11em;
									background-color: #086CCC;
									transition: width .5s ease;
								}
							}


						}
					}
				}
			}
		}
	}
</style>